<template>
  <div>
    <!-- 화면 제목 -->
    <v-row class="title-wrap">
      <v-col cols="12" class="icon-title word-type pb-5">
        <icon-notice :width="22" :height="22" />공지사항
      </v-col>
    </v-row>

    <!-- empty Data component -->
    <empty-data v-if="emptyDataFlag" v-bind:text="emptyDataText"></empty-data>

    <!-- 게시글리스트 -->
    <div v-else>
      <!-- A. 상단고정게시글(중요공지) -->
      <top-post-list
        v-bind:searchList="topPostList"
        v-on:selectItem="openModal"
      ></top-post-list>
      <!-- B. 일반게시글 -->
      <post-list
        v-bind:searchList="postList"
        v-on:selectItem="openModal"
      ></post-list>

      <!-- 더 보기 버튼 -->
      <v-row
        align="center"
        justify="space-around"
        class="ma-0 mt-8 mb-8"
        v-show="moreBtnShowFlag"
      >
        <v-btn elevation="0" class="btn-more" height="38" @click="searchMore()">
          <span class="black--text">
            <v-icon size="18" class="mt-n1">mdi-chevron-down</v-icon>
            더보기
          </span>
        </v-btn>
      </v-row>
    </div>

    <!---------------------------------------------------------------------------->
    <!-- 공지사항 상세 모달 -->
    <board-detail-dialog v-bind:postId="selectPostId"></board-detail-dialog>
  </div>
</template>

<script>
/* 공지사항 */
import EmptyData from '@/components/common/EmptyData.vue';
import TopPostList from '@/components/board/TopBoardList.vue';
import PostList from '@/components/board/PostList.vue';
import BoardDetailDialog from '@/components/board/dialog/BoardDetailDialog.vue';
import IconNotice from '@/assets/customIcon/IconNotice.vue';
import { getBoardDefOption, getBoardList } from '@/api/board';
import { getDate } from '@/utils/common/dateUtil';
import dayjs from 'dayjs';

export default {
  data: () => ({
    emptyDataFlag: false, // 조회결과없음 플래그

    tenantKey: '',
    boardDefKey: '',

    boardDefInfo: {}, // 게시판정보
    topPostList: [], // 상단고정 게시글리스트(중요공지)
    postList: [], // 게시글리스트
    selectPostId: '', // 선택게시글아이디

    totalPageCnt: 0, // 총페이지수
    currPageNo: 0, // 현재페이지번호
  }),

  computed: {
    GET_USER_DATA() {
      return this.$store.getters.GET_USER_DATA;
    },
    moreBtnShowFlag() {
      return this.totalPageCnt > this.currPageNo;
    },
  },

  methods: {
    /* 중요게시글리스트추가 */
    addTopPostList(dataList) {
      dataList.forEach(data => {
        this.topPostList.push({
          postId: data.postId,
          title: data.title,
          createDate: getDate(data.createDate),
          createUserName: data.createUserName,
          createUserId: data.createUserId,
          viewCnt: data.viewCount,
          topFlag: data.topFlag,
        });
      });
    },

    /* 게시글리스트추가 */
    addPostList(dataList) {
      dataList.forEach(data => {
        this.postList.push({
          postId: data.postId,
          title: data.title,
          createDate: getDate(data.createDate),
          createUserName: data.createUserName,
          createUserId: data.createUserId,
          viewCnt: data.viewCount,
          topFlag: data.topFlag,
        });
      });
    },

    /* 더보기 */
    searchMore() {
      // 공통 스피너 ON
      this.$store.commit('SPINNER/ON_COMMON_SPINNER');

      this.fetchBoardList();
    },

    /* 모달 open */
    openModal(param) {
      this.selectPostId = param;
      this.$store.commit('DIALOG/TOGGLE_MODAL', 'board_detail');
    },

    /* 게시판속성정보조회 */
    async fetchBoardDefOption() {
      try {
        const response = await getBoardDefOption({
          tenantKey: this.tenantKey,
          boardDefKey: this.boardDefKey,
        });

        if (response.data.message === 'OK' && response.data.data !== null) {
          this.boardDefInfo = response.data.data;
        }
        return response;
      } catch (error) {
        console.log(error);
      }
    },

    /* 공지사항 목록조회 */
    async fetchBoardList() {
      const paramObj = {
        tenantKey: this.tenantKey,
        boardDefKey: this.boardDefKey,
        currentPage: ++this.currPageNo,
        sCreateStartDate: dayjs().subtract(1, 'year').format('YYYYMMDDHHmmss'),
        sCreateEndDate: dayjs().format('YYYYMMDDHHmmss'), // 조회기간(최근 1년)
      };

      try {
        const response = await getBoardList(paramObj); // 공지사항 목록조회 api 호출

        if (response.data.message === 'OK' && response.data.data !== null) {
          const dataList = response.data.data;

          // 총페이지수 저장
          this.totalPageCnt = dataList.pageInfo.totalPage;

          // 첫페이지 조회시 and '중요게시글'이 있는 경우 상단고정 게시글리스트에 추가
          if (
            this.currPageNo === 1 &&
            this.boardDefInfo.topUseFlag === 'Y' &&
            dataList.topPostList.length !== null
          ) {
            this.addTopPostList(dataList.topPostList);
          }

          if (dataList.postList.length > 0) {
            this.addPostList(dataList.postList);
          } else {
            this.emptyDataFlag = true;
          }
        }

        // 공통 스피너 OFF
        this.$store.commit('SPINNER/OFF_COMMON_SPINNER');
      } catch (error) {
        console.log(error);
        // 공통 스피너 OFF
        this.$store.commit('SPINNER/OFF_COMMON_SPINNER');
      }
    },
  },

  created() {
    // 공통 스피너 ON
    this.$store.commit('SPINNER/ON_COMMON_SPINNER');

    this.tenantKey = this.GET_USER_DATA.ssnEnterCd;
    this.boardDefKey = `${this.GET_USER_DATA.ssnEnterCd}_B2`; // 공지사항

    this.fetchBoardDefOption();
    this.fetchBoardList();
  },

  components: {
    EmptyData,
    TopPostList,
    PostList,
    BoardDetailDialog,
    IconNotice,
  },
};
</script>
<style></style>
